import Vue from "vue";
import CompetitorSpeechBubble from "./index.vue";
import {
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
} from "./types";

export default Vue.extend<
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
>({
  computed: {
    selectedEvent() {
      return this.$store.getters["pages/plan/getSelectedStudentEvent"];
    },
    plan() {
      return this.$store.state.pages.plan.applicationPlan;
    },
    selectedStudent() {
      return this.$store.state.pages.plan.selectedStudent;
    },
    speechBubble() {
      return this.$store.state.pages.plan.speechBubble;
    }
  },
  methods: {
    handleKeyupEsc() {
      this.initSelectedEvent();
    },
    initSelectedEvent() {
      this.$store.commit("pages/plan/updateSelectedEvent", {
        event: undefined
      });
    }
  },
  render(createElement) {
    return createElement(CompetitorSpeechBubble, {
      props: {
        planGraduateYear: this.plan ? this.plan.graduate_year : undefined,
        selectedEvent: this.selectedEvent,
        selectedStudent: this.selectedStudent,
        speechBubble: this.speechBubble
      },
      on: {
        keyupEsc: this.handleKeyupEsc
      }
    });
  }
});
